export default "__VITE_ASSET__C_kQNwQO__"